<div
	role="toolbar"
	class="flex justify-center items-center bg-apryse-100 border-b p-2 border-gray-200"
>
	<div class="flex *:flex *:justify-center bg-apryse-50 rounded gap-1">
		<span
			class="flex px-1 rounded items-center after:content-['%'] focus-within:bg-blue-100 has-[input:hover]:bg-blue-100"
		>
			<input
				class="bg-transparent text-end rounded-sm"
				[ngClass]="inputModel_().length === maxLength ? 'w-[4ch]' : 'w-[3ch]'"
				type="text"
				inputmode="numeric"
				[pattern]="validPattern"
				[minLength]="minLength"
				[maxLength]="maxLength"
				aria-label="Set zoom"
				[(ngModel)]="inputModel_"
				(blur)="setPercentage($event.target)"
				(keyup.enter)="setPercentage($event.target)"
				(keypress)="onKeyPress($event)"
			/>
		</span>

		<div
			class="*:flex [&>button:hover]:bg-blue-100 *:items-center *:size-8 *:justify-center transition-opacity duration-300 text-gray-500"
		>
			<button
				class="rounded-l"
				matTooltip="Zoom out"
				aria-label="Zoom out"
				(click)="zoomOut.emit()"
			>
				<i-tabler class="size-6" name="circle-minus" />
			</button>
			<button
				class="rounded-r"
				matTooltip="Zoom in"
				aria-label="Zoom in"
				(click)="zoomIn.emit()"
			>
				<i-tabler class="size-6" name="circle-plus" />
			</button>
		</div>
	</div>
</div>
